import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-none d-md-block row" }
const _hoisted_2 = { class: "d-md-none row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex border-bottom border-bottom-2 border-bottom-primary pb-4" }
const _hoisted_5 = {
  class: "cursor-pointer",
  style: {"flex":"1"}
}
const _hoisted_6 = { class: "m-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex ms-auto",
  style: {"flex":"1"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showChevron)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                  class: "fa fa-chevron-left fs-2 pe-4 p-1"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.mobileHeader), 1),
          _hoisted_7
        ]),
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}